import { render } from "./Viewer3DOverlay.vue?vue&type=template&id=754694d2&scoped=true"
import script from "./Viewer3DOverlay.vue?vue&type=script&lang=js"
export * from "./Viewer3DOverlay.vue?vue&type=script&lang=js"

import "./Viewer3DOverlay.vue?vue&type=style&index=0&id=754694d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754694d2"]])

export default __exports__